import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'hideExtension',
    standalone: false
})
export class HideExtPipe implements PipeTransform {
  transform(fileName: string): string {
    return fileName ? fileName.substring(0, fileName.lastIndexOf('.')) + '.pdf' : '';
  }
}

